module.exports = __webpack_public_path__ + "static/06-326f1448c684cd28c08dee71ac583422.jpg";